import { baseUrl } from "../utils/baseUrl";
import jwtInterceoptor from "./autorizacao/jwt-interceptor";

class ServicosSetores {
    create(setor) {
        return jwtInterceoptor.post(`${baseUrl}/setores`, setor)
    }
    listarTodos(){
        return jwtInterceoptor.get(`${baseUrl}/setores`)
    }
    editar(id, setor){
        return jwtInterceoptor.put(`${baseUrl}/setores/${id}`, setor)
    }
    deletar(id){
        return jwtInterceoptor.delete(`${baseUrl}/setores/${id}`)
    }
}

export default new ServicosSetores();